import React, { useEffect, useState } from "react";
import { Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import ProductModalityTab from "./ProductModalityTab";
import ManufacturingSupplyTab from "./ManufacturingSupplyTab";
import PlantTypeTab from "./PlantTypeTab";
import UOMTab from "./UOMTab";
import ProductTypeTab from "./ProductTypeTab";
import MaterialTypeTab from "./MaterialTypeTab";
import BatchStatusTab from "./BatchStatusTab";
import FormatTypeTab from "./FormatTypeTab";
import UploadFetchSettingTab from "./UploadFetchSettingTab";
import POStatusTab from "./POStatusTab";
import ShipmentStatusTab from "./ShipmentStatusTab";
import TemperatureTab from "./TemperatureTab";
import TruckCapacityTab from "./TruckCapacityTab";
import ProjectStatusTab from "./ProjectStatusTab";
import CampaignStatusTab from "./CampaignStatusTab";
import ChangeControlStatusTab from "./ChangeControlStatusTab";
import DeviationStatusTab from "./DeviationStatusTab";
import TestsTab from "./TestsTab";
import StatusManagementTab from "./StatusManagementTab";
import DocumentCategoriesTab from "./DocumentCategoriesTab";
import DocumentTypeTab from "./DocumentTypeTab";
import DocumentGroupsTab from "./DocumentGroupsTab";
import ManufacturingFacilityTypeTab from "./ManufacturingFacilityTypeTab";
import ReasonCodeGroupTab from "./ReasonCodeGroupTab";
import DigitalizationCodesTab from "./DigitalizationCodeTab";
import ShipmentConfigTab from "./ShipmentConfigTab";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import ProcessFlowTab from "./ProcessFlowTab";
import RecheckTimeWindowTab from "./RecheckTimeWindowTab";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";
import jwtDecode from "jwt-decode";
// Custom Tab implementation
const CustomTab = ({ label, isActive, onClick }) => {
  const classes = useStyles();

  return (
    <div
      className={`${classes.customTab} ${isActive ? classes.activeTab : ""}`}
      onClick={onClick}
    >
      {label}
      {isActive && <div className={classes.tabIndicator} />}
    </div>
  );
};

// Custom TabPanel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`custom-tabpanel-${index}`}
      aria-labelledby={`custom-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(0),
    padding: "2rem",
  },
  headerContainer: {
    marginBottom: theme.spacing(2),
  },
  headerText: {
    fontSize: "1.5rem",
    fontWeight: 600,
  },
  headerLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "4px 0 0 0",
  },
  tabsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "10px",
  },
  customTab: {
    textTransform: "none",
    fontSize: "1rem",
    cursor: "pointer",
    color: "#555",
    position: "relative",
    padding: "8px 0",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    "&:hover": {
      color: "#1976d2",
    },
  },
  activeTab: {
    fontWeight: 600,
    // color: "#1976d2",
    color: "#1890FF",
  },
  tabIndicator: {
    position: "absolute",
    bottom: -2,
    left: 0,
    right: 0,
    height: "3px",
    backgroundColor: "#1890FF",
    borderRadius: "2px",
  },
  tabContent: {
    marginTop: theme.spacing(2),
  },
}));

// Mock components for each tab
const ProductModalityComponent = (props) => (
  <div>
    <ProductModalityTab
    // handleNext={props.handleNext}
    />
  </div>
);

const ManufacturingSupplyTypeComponent = (props) => (
  <div>
    <ManufacturingSupplyTab
    // handleNext={props.handleNext}
    // handleBack={props.handleBack}
    />
  </div>
);
const PlantTypeComponent = () => (
  <div>
    <PlantTypeTab />
  </div>
);
const UOMComponent = () => (
  <div>
    <UOMTab />
  </div>
);
const ReasonCodeGroupComponent = ({setReasonCodesData, featuresAccess}) => (
  <div>
    <ReasonCodeGroupTab 
      setReasonCodesData={setReasonCodesData} 
      featuresAccess={featuresAccess}
    />
  </div>
);
const ProductTypeComponent = () => (
  <div>
    <ProductTypeTab />
  </div>
);
const ManufacturingFacilityTypeComponent = () => (
  <div>
    <ManufacturingFacilityTypeTab />
  </div>
);
const POStatusComponent = () => (
  <div>
    <POStatusTab />
  </div>
);
const BatchStatusComponent = () => (
  <div>
    <BatchStatusTab />
  </div>
);
const ShipmentStatusComponent = () => (
  <div>
    <ShipmentStatusTab />
  </div>
);
const DocumentTypeComponent = () => (
  <div>
    <DocumentTypeTab />
  </div>
);
const DocumentCategoriesComponent = () => (
  <div>
    <DocumentCategoriesTab />
  </div>
);
const FormatTypeComponent = () => (
  <div>
    <FormatTypeTab />
  </div>
);
// const FetchUploadSettingComponent = () => (
//   <div>
//     <UploadFetchSettingTab />
//   </div>
// );

const SponsorNetworkTabs = ({
  openedTab,
  handleOpenTab,
  sponsorHandleNext,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState(openedTab !== undefined ? openedTab : 0);
  
  const getOrganizationIdFromToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return decoded.organization_id;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };
  
  const sponsorId = getOrganizationIdFromToken();
  const [modalities, setModalities] = useState([]);

   
  // Get screen access and features access from Redux
  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess.data
        .manageSponsorNetwork
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.manageSponsorNetwork
  );

  // Fetch features access when screen access is available
  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess) {
      dispatch(
        getFeaturesAccess(screenAccess?.screenId, "manageSponsorNetwork")
      );
    }
  }, [dispatch, screenAccess, featuresAccess]);
  
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
      const [poStatuses, setPoStatuses] = useState([]);
     const [facilityTypes, setFacilityTypes] = useState([]);
     const [productTypes, setProductTypes] = useState([]);
     const [materialTypes, setMaterialTypes] = useState([]);
    const [plantTypes, setPlantTypes] = useState([]);
  const [uoms, setUoms] = useState([]);
    const [formatTypes, setFormatTypes] = useState([]);
    const [digitalizationCodes, setDigitalizationCodes] = useState([]);
     const [documentTypes, setDocumentTypes] = useState([]);
     const [documentCategories, setDocumentCategories] = useState([]);
     const [documentGroups, setDocumentGroups] = useState([]);
      const [shipmentStatuses, setShipmentStatuses] = useState([]);
        const [batchStatuses, setBatchStatuses] = useState([]);
      const [projectStatuses, setProjectStatuses] = useState([]);
      const [campaignStatuses, setCampaignStatuses] = useState([]);
      const [changeControlStatuses, setChangeControlStatuses] = useState([]);
      const [deviationStatuses, setDeviationStatuses] = useState([]);
      const [inProcessTestStatuses, setInProcessTestStatuses] = useState([]);
      const [productReleaseTestStatuses, setProductReleaseTestStatuses] = useState([]);
  const [supplyTypes, setSupplyTypes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
    const [lastSyncTime, setLastSyncTime] = useState(new Date());
    const [uploadSuccess, setUploadSuccess] = useState(false);
     const [reasonCodes, setReasonCodes] = useState([]);
     const [productModalities, setProductModalities] = useState(false);
     const [manufacturingSupplyTypes, setManufacturingSupplyTypes] = useState(false);
  const [plantType, setPlantType] = useState(false);
  const [reasonCodesData, setReasonCodesData] = useState(false);
  const [uom, setUom] = useState(false);
  const [productType, setProductType] = useState(false);
  const [materialType, setMaterialType] = useState(false);
  const [manufacturingFacilityType, setManufacturingFacilityType] = useState(false);
  const [poStatus, setPoStatus] = useState(false);
  const [batchStatus, setBatchStatus] = useState(false);
  const [shipmentStatus, setShipmentStatus] = useState(false);
  // 3PL Logistics — Sponsor Network: new master-data tabs (FSD)
  const [temperatures, setTemperatures] = useState([]);
  const [temperature, setTemperature] = useState(false);
  const [truckCapacities, setTruckCapacities] = useState([]);
  const [truckCapacity, setTruckCapacity] = useState(false);
  const [projectStatus, setProjectStatus] = useState(false);
  const [campaignStatus, setCampaignStatus] = useState(false);
  const [changeControlStatus, setChangeControlStatus] = useState(false);
  const [deviationStatus, setDeviationStatus] = useState(false);
  const [inProcessTestStatus, setInProcessTestStatus] = useState(false);
  const [productReleaseTestStatus, setProductReleaseTestStatus] = useState(false);
  const [documentType, setDocumentType] = useState(false);
  const [documentCategory, setDocumentCategory] = useState(false);
  const [documentGroup, setDocumentGroup] = useState(false);
  const [formatType, setFormatType] = useState(false);
  const [digitalizationCode, setDigitalizationCode] = useState(false);
  const [processFlows, setProcessFlows] = useState([]);
  const [processFlow, setProcessFlow] = useState(false);
const [shipmentConfigs, setShipmentConfigs] = useState([]);
  const [shipmentConfig, setShipmentConfig] = useState(false);  
  const [recheckTimeWindows, setRecheckTimeWindows] = useState([]);
  const [recheckTimeWindowRefresh, setRecheckTimeWindowRefresh] = useState(false);
  const [recheckLoading, setRecheckLoading] = useState(false);
  const [recheckError, setRecheckError] = useState(null);
  
     const [filters, setFilters] = useState({
         searchBy: "",
         searchTerm: "",
         reasonCodeType: "all",
         reasonCodeGroupType: "all",
         status: "all",
       });


   const fetchProductModalities = async () => {
      setLoading(true);
      setError(null); // Reset error state before new fetch
  
      // Open backdrop before API call
     
  
      try {
        const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypes/true`;
  
        const response = await axios.get(url);
  
        const drugTypeList = response.data?.data?.drugTypeList || [];
  
        const formatted = drugTypeList.map((item, index) => ({
          ...item,
          id: item.drugTypeID || `ID-${index + 1}`,
          name: item.drugTypeName || "",
          selected: !!item.activated,
          isNew: false,
          type: item.drugType,
          lastUpdatedBy: item.lastUpdatedBy,
        }));
  
        setModalities(formatted);
      } catch (error) {
        setError("Something went wrong. Please try again.");
      } finally {
        // Always close backdrop and stop loading
        
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchProductModalities(setModalities, setLoading);
    }, [productModalities]);

      const fetchPlantSupplyTypes = async () => {
        setError(null);
        setLoading(true);
      
    
        try {
          const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantSupplyTypes/false`;
          const response = await axios.get(url);
    
          if (response.data?.data?.status) {
            const list = response.data.data.supplyTypeList || [];
            const formatted = list.map((item, index) => ({
              ...item,
              id: item.supplyTypeID || `ID-${index + 1}`,
              name: item.supplyTypeName || "",
              selected: !!item.activated,
              isNew: false,
            }));
    
            setSupplyTypes(formatted);
          } else {
            setError("Something went wrong. Please try again.");
            console.error("Failed to fetch product types");
          }
        } catch (error) {
          setError("Something went wrong. Please try again.");
          console.error("Error fetching product types:", error);
        } finally {
          setLoading(false);
        
        }
      };
    
      useEffect(() => {
        fetchPlantSupplyTypes();
      }, [manufacturingSupplyTypes]);

        const fetchPlantTypes = async () => {
          setError(null);
          setLoading(true);
         
      
          try {
            const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantTypes/false`;
            const response = await axios.get(url);
            const data = response?.data?.data;
      
      
            if (data?.status === true || data?.status === "true") {
              const list = data.plantTypeList || [];
      
              const formatted = list.map((item, index) => ({
                ...item,
                id: item.plantTypeID,
                name: item.plantTypeName,
                selected: !!item.activated,
                isNew: false,
                supplyType: item.plantType,
              }));
      
              setPlantTypes(formatted);
            } else {
              setError("Something went wrong. Please try again.");
            }
          } catch (err) {
            console.error("API Error:", err);
            setError("Something went wrong. Please try again.");
          } finally {
            setLoading(false);
            
          }
        };
      
        useEffect(() => {
          fetchPlantTypes();
        }, [plantType]);

         const fetchUOMs = async () => {
            setError(null);
            setLoading(true);
          
        
            try {
              const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllUOMs/false`;
              const response = await axios.get(url);
              const data = response?.data?.data;
        
        
              const list = data.productUOMsList || [];
              if (data?.status === true || data?.status === "true") {
                const formatted = list.map((item, index) => ({
                  id: item.uomID,
                  name: item.uom,
                  selected: !!item.activated,
                  isNew: false,
                  uomType: item.uomType,
                  lastUpdatedBy: item.lastUpdatedBy,
                }));
                setUoms(formatted);
              } else {
                setError("Something went wrong. Please try again.");
              }
            } catch (err) {
              console.error("API Error:", err);
              setError("Something went wrong. Please try again.");
            } finally {
              setLoading(false);
            
            }
          };
          useEffect(() => {
            fetchUOMs();
          }, [uom]);

            const fetchReasonCodes = async (updatedFilters = filters) => {
    setLoading(true);
    setError(null); // Reset error state before new fetch

    // Open backdrop before API call
   

    try {
      const requestObject = {
        searchField: updatedFilters.searchBy || "all",
        searchValue: updatedFilters.searchTerm || "",
        reasonCodeGroupType: updatedFilters.reasonCodeGroupType || "all",
        reasonCodeType: updatedFilters.reasonCodeType || "all",
        status: updatedFilters.status || "all",
        collaboratorTypeID: "all",
      };

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodes`;

      const response = await axios.post(url, requestObject);
      if (response.data.status) {
        const result = response.data.data.reasonCodeList || [];
        setReasonCodes(result);
        setFilteredData(result);
        setLastSyncTime(new Date());
      }

      // Close backdrop after successful response
   
    } catch (error) {
      setError("Something went wrong. Please try again.");

      // Close backdrop on error
     
    } finally {
      setLoading(false);
      setUploadSuccess(false);
    }
  };

  // On component mount, fetch data
  useEffect(() => {
    fetchReasonCodes();
  }, [reasonCodesData]);

  
  const fetchProductTypes = async () => {
    setError(null);
    setLoading(true);
   

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/true`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const list = data.productTypeList || [];

        const formatted = list.map((item, index) => ({
          id: item.productTypeID || `ID-${index + 1}`,
          name: item.productTypeName || "",
          type: item.productType,
          selected: !!item.activated,
          isNew: false,
        }));

        setProductTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
     
    }
  };
  useEffect(() => {
    fetchProductTypes();
  }, [productType]);

  const fetchMaterialTypes = async () => {
    // return
    setError(null);
    setLoading(true);

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchMaterialTypes/false`;
      const response = await axios.get(url);
      const data = response?.data;

      //console.log("API Material Type Data:", data);

      if (data?.status === true || data?.status === "true") {
        const list = data.materialTypeList || [];

        const formatted = list.map((item, index) => ({
          id: item.materialTypeID || `ID-${index + 1}`,
          name: item.materialTypeName || "",
          type: item.materialType,
          selected: !!item.activated,
          isNew: false,
        }));

        setMaterialTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaterialTypes();
  }, [materialType]);

    const fetchFacilityTypes = async () => {
    try {
      setLoading(true); // Show loading indicator
      setError(null); // Clear any previous errors

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFacilityTypes/false`;
      const response = await axios.get(url);

      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const list = data.facilityTypesList || [];

        const formatted = list.map((item, index) => ({
          id: item.facilityTypeID || `ID-${index + 1}`,
          name: item.facilityTypeName || "",
          type: item.facilityType || "default",
          selected: !!item.activated,
          associatedProductTypes: (item.associatedProductTypes || []).map(
            (product) => ({
              id: product.productTypeID,
              name: product.productTypeName,
            })
          ),
          lastUpdatedBy: item.lastUpdatedBy || "",
          isNew: false,
        }));

        setFacilityTypes(formatted); 
          setError("");// Update the state with the fetched facility types
      } 
    } catch (error) {
      console.error("Error fetching facility types:", error);
       setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Hide loading indicator
    }
  };

  useEffect(() => {
    fetchFacilityTypes();
    // fetchProductOptions();
  }, [manufacturingFacilityType]);

  
    const fetchPoStatuses = async () => {
      setLoading(true); // Show loading spinner
      setError(""); // Reset error state
      try {
        const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFGStatuses/false`; // API endpoint
        const response = await axios.get(url);
  
        if (response.data?.status === true || response.data?.status === "true") {
          // Map the API response to match the expected structure
          const mappedStatuses = response.data?.data?.poStatuses?.map(
            (status) => ({
              id: status.status_id,
              name: status.status_name,
              selected: status.activated,
              type: status.status_type,
              isNew: false,
              newStatusName: status.newStatusName,
              lastUpdatedBy: status.last_updated_by,
            })
          );
  
          setPoStatuses(mappedStatuses || []); // Update state with mapped statuses
        } else {
          console.error("Failed to fetch PO statuses:", response.data?.message);
          setError(response.data?.message || "Failed to fetch PO statuses.");
        }
      } catch (error) {
        console.error("Error fetching PO statuses:", error);
        setError("An error occurred while fetching PO statuses.");
      } finally {
        setLoading(false); // Hide loading spinner
      }
    };
  
    useEffect(() => {
      fetchPoStatuses();
    }, [poStatus]);

      const fetchBatchStatuses = async () => {
    setError(null);
    setLoading(true);

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFGStatuses/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (response.data?.status === true || response.data?.status === "true") {
        const list = data?.batchStatuses || [];

        // Map the API response to match the expected structure
        const formattedStatuses = list.map((item, index) => ({
          id: item.status_id || `ID-${index + 1}`,
          name: item.status_name || "",
          selected: !!item.activated,
          isNew: false,
          type: item.status_type,
          newName: item.newStatusName,
        }));

        setBatchStatuses(formattedStatuses);
      } else {
        console.error(
          "Failed to fetch batch statuses:",
          response.data?.message
        );
        setError(response.data?.message || "Failed to fetch batch statuses.");
      }
    } catch (error) {
      console.error("Error fetching batch statuses:", error);
      setError("An error occurred while fetching batch statuses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBatchStatuses();
  }, [batchStatus]);
   const fetchShipmentStatuses = async () => {
    setError(null); // Reset error state
    setLoading(true); // Show loading spinner

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFGStatuses/false`; // API endpoint
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (response.data?.status === true || response.data?.status === "true") {
        const list = data?.shipmentStatuses || [];

        // Map the API response to match the expected structure
        const formattedStatuses = list.map((item, index) => ({
          id: item.status_id || `ID-${index + 1}`, // Use ID from API or generate one
          name: item.status_name || "", // Use name from API or fallback
          selected: !!item.activated, // Convert activation state to boolean
          type: item.status_type,
          isNew: false,
          lastUpdatedBy: item.last_updated_by,

          newStatusName: item.newStatusName , // Default to empty string for fetched statuses
        }));

        setShipmentStatuses(formattedStatuses); // Update state with formatted statuses
      } else {
        console.error(
          "Failed to fetch shipment statuses:",
          response.data?.message
        );
        setError(
          response.data?.message || "Failed to fetch shipment statuses."
        );
      }
    } catch (error) {
      console.error("Error fetching shipment statuses:", error);
      setError("An error occurred while fetching shipment statuses.");
    } finally {
      setLoading(false); // Hide loading spinner
    }
  };
  useEffect(() => {
    fetchShipmentStatuses();
  }, [shipmentStatus]);

  // 3PL Logistics — count fetchers for the new master-data tabs.
  // Endpoints per Logistics Dashboard API spec:
  //   /fetchTemperatureDetails/{networkConfig}
  //   /fetchTruckCapacityDetails/{networkConfig}
  // networkConfig=true → returns all rows (active + inactive) for the network
  // config screen badge count. Falls back to 3 FSD defaults silently when the
  // endpoint is not yet live so the badge still renders.
  const fetchTemperaturesCount = async () => {
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchTemperatureDetails/true`;
      const response = await axios.get(url);
      const list = response?.data?.temperatureDetails || response?.data?.data?.temperatureDetails || [];
      // FSD defaults: Ambient, Coldstore, Dual (3)
      setTemperatures(list.length > 0 ? list.filter((t) => !t.markForDelete) : [{}, {}, {}]);
    } catch (err) {
      setTemperatures([{}, {}, {}]);
    }
  };
  useEffect(() => {
    fetchTemperaturesCount();
  }, [temperature]);

  const fetchTruckCapacitiesCount = async () => {
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchTruckCapacityDetails/true`;
      const response = await axios.get(url);
      const list = response?.data?.truckCapacityDetails || response?.data?.data?.truckCapacityDetails || [];
      // FSD defaults: All, Standard, Double Stacked (3)
      setTruckCapacities(list.length > 0 ? list.filter((t) => !t.markForDelete) : [{}, {}, {}]);
    } catch (err) {
      setTruckCapacities([{}, {}, {}]);
    }
  };
  useEffect(() => {
    fetchTruckCapacitiesCount();
  }, [truckCapacity]);

  // Fetch all PD Statuses using fetchPDStatuses API (single call for all 6 types)
  const fetchPDStatuses = async () => {
    setError(null);
    setLoading(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPDStatuses/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;

      if (response.data?.status === true || response.data?.status === "true") {
        // Map all 6 status types from single API call
        const projectList = data?.projectStatuses || [];
        const formattedProjectStatuses = projectList.map((item, index) => ({
          id: item.statusID || item.status_id || `ID-${index + 1}`,
          name: item.statusName || item.status_name || "",
          selected: !!item.activated,
          type: item.statusType || item.status_type,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || item.last_updated_by,
          newStatusName: item.newStatusName || null,
        }));
        setProjectStatuses(formattedProjectStatuses);
        
        const campaignList = data?.campaignStatuses || [];
        const formattedCampaignStatuses = campaignList.map((item, index) => ({
          id: item.statusID || item.status_id || `ID-${index + 1}`,
          name: item.statusName || item.status_name || "",
          selected: !!item.activated,
          type: item.statusType || item.status_type,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || item.last_updated_by,
          newStatusName: item.newStatusName || null,
        }));
        setCampaignStatuses(formattedCampaignStatuses);
        
        const changeControlList = data?.changeControlStatuses || [];
        const formattedChangeControlStatuses = changeControlList.map((item, index) => ({
          id: item.statusID || item.status_id || `ID-${index + 1}`,
          name: item.statusName || item.status_name || "",
          selectedBms: !!item.activated_bms,
          selectedCmo: !!item.activated_cmo,
          type: item.statusType || item.status_type,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || item.last_updated_by,
          newStatusName: item.newStatusName || null,
        }));
        setChangeControlStatuses(formattedChangeControlStatuses);
        
        const deviationList = data?.deviationStatuses || [];
        const formattedDeviationStatuses = deviationList.map((item, index) => ({
          id: item.statusID || item.status_id || `ID-${index + 1}`,
          name: item.statusName || item.status_name || "",
          selectedBms: !!item.activated_bms,
          selectedCmo: !!item.activated_cmo,
          type: item.statusType || item.status_type,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || item.last_updated_by,
          newStatusName: item.newStatusName || null,
        }));
        setDeviationStatuses(formattedDeviationStatuses);
        
        const inProcessList = data?.inProcessTestStatuses || [];
        const formattedInProcessStatuses = inProcessList.map((item, index) => ({
          id: item.statusID || item.status_id || `ID-${index + 1}`,
          name: item.statusName || item.status_name || "",
          selectedBms: !!item.activated_bms,
          selectedCmo: !!item.activated_cmo,
          type: item.statusType || item.status_type,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || item.last_updated_by,
          newStatusName: item.newStatusName || null,
        }));
        setInProcessTestStatuses(formattedInProcessStatuses);
        
        const productReleaseList = data?.productReleaseTestStatuses || [];
        const formattedProductReleaseStatuses = productReleaseList.map((item, index) => ({
          id: item.statusID || item.status_id || `ID-${index + 1}`,
          name: item.statusName || item.status_name || "",
          selectedBms: !!item.activated_bms,
          selectedCmo: !!item.activated_cmo,
          type: item.statusType || item.status_type,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || item.last_updated_by,
          newStatusName: item.newStatusName || null,
        }));
        setProductReleaseTestStatuses(formattedProductReleaseStatuses);
      }
    } catch (error) {
      console.error("Error fetching PD statuses:", error);
    } finally {
      setLoading(false);
    }
  };
  
  // Fetch on mount
  useEffect(() => {
    fetchPDStatuses();
  }, []);

   const fetchDocumentTypes = async () => {
      setLoading(true); // Show the loading spinner
      setError(""); // Reset error state before making the API call
      try {
        const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDocumentTypes/false`; // API endpoint
        const response = await axios.get(url);
  
  
        if (response.data?.status === true || response.data?.status === "true") {
          // Check if documentTypeList exists and is an array
          const documentTypesList = response.data?.data?.documentTypesList || [];
  
  
          // Map the API response to match the expected structure
          const mappedDocumentTypes = documentTypesList.map((doc) => ({
            id: doc.documentTypeID, // Map documentTypeID to id with fallback
            name: doc.documentTypeName, // Map documentTypeName to name with fallback
            selected: !!doc.activated, // Map activated to selected, convert to boolean
            isNew: false,
            newDocumentTypeName: doc.newDocumentTypeName,
            type: doc.documentType,
            lastUpdatedBy: doc.lastUpdatedBy,
  
            // Default to false for fetched document types
          }));
  
          setDocumentTypes(mappedDocumentTypes); // Update state with mapped document types
        } else {
          console.error(
            "Failed to fetch document types:",
            response.data?.message
          );
          setError(
            response.data?.message || "Something went wrong. Please try again."
          ); // Set error message
        }
      } catch (error) {
        console.error("Error fetching document types:", error);
        setError("Something went wrong. Please try again."); // Set error message
      } finally {
        setLoading(false); // Hide the loading spinner
      }
    };
  
  useEffect(() => {
    fetchDocumentTypes(); // Fetch document types on component mount
  }, [documentType]);

  const fetchDocumentCategories = async () => {
    setLoading(true); // Show the loading spinner
    setError(""); // Reset error state before making the API call
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDocumentCategories/false`;
      const response = await axios.get(url);
      
      if (response.data?.status === true || response.data?.status === "true") {
        const documentCategoryList = response.data?.documentCategoryList || [];
        const mappedDocumentCategories = documentCategoryList.map((doc) => ({
          id: doc.documentCategoryID,
          name: doc.documentCategoryName,
          selected: !!doc.activated,
          isNew: false,
          type: doc.documentCategoryType,
          lastUpdatedBy: doc.lastUpdatedBy,
        }));
        setDocumentCategories(mappedDocumentCategories);
      } else {
        console.error("Failed to fetch document categories:", response.data?.message);
        setError(response.data?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching document categories:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentCategories();
  }, [documentCategory]);

  const fetchDocumentGroups = async () => {
    setLoading(true);
    setError("");
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDocumentGroups/false`;
      const response = await axios.get(url);
      
      if (response.data?.status === true || response.data?.status === "true") {
        const documentGroupsList = response.data?.data?.documentGroups || [];
        const mappedDocumentGroups = documentGroupsList.map((doc) => ({
          id: doc.documentGroupID,
          name: doc.documentGroupName,
          selected: !!doc.activated,
          isNew: false,
          type: doc.documentGroupType,
          lastUpdatedBy: doc.lastUpdatedBy,
        }));
        setDocumentGroups(mappedDocumentGroups);
      } else {
        console.error("Failed to fetch document groups:", response.data?.message);
        setError(response.data?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching document groups:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentGroups();
  }, [documentGroup]);

  const fetchFormatTypes = async () => {
    setError(null);
    setLoading(true);
  

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFileFormatTypes/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const list = data.fileFormatTypesList || [];

        const formatted = list.map((item, index) => ({
          id: item.fileFormatTypeID || `ID-${index + 1}`,
          name: item.fileFormatTypeName || "",
          selected: !!item.activated,
          isNew: false,
          type: item.fileFormatType,
        }));

        setFormatTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
     
    }
  };

  useEffect(() => {
    
    fetchFormatTypes();

  }, [formatType]);

  const fetchDigitalizationCodes = async () => {
  setError(null);
  setLoading(true);
  try {
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDigitalizationCodes`;
    const response = await axios.get(url);
    const data = response?.data;
    if (data?.status === true || data?.status === "true") {
      const list = data.digitalizationCodesList || [];
      const formatted = list.map((item, index) => ({
        id: item.digitalizationCodeID || `ID-${index + 1}`,
        code: item.digitalizationCode || "",
        description: item.digitalizationCodeDescription || "",
        selected: !!item.activated,
        isNew: false,
        type: item.digitalizationCodeType,
      }));
      setDigitalizationCodes(formatted);
    } else {
      setError("Something went wrong. Please try again.");
    }
  } catch (err) {
    console.error("API Error:", err);
    setError("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};

// ==== 4. useEffect to load on mount and refresh ====
useEffect(() => {
  fetchDigitalizationCodes();
}, [digitalizationCode])

  const fetchProcessFlows = async () => {
    setError(null);
    setLoading(true);

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllProcessFlows/false`;
      const response = await axios.get(url);
      
      if (response.data && response.data.status && response.data.processFlowsList) {
        const processFlowsList = response.data.processFlowsList;
        setProcessFlows(processFlowsList);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProcessFlows();
  }, []);

  useEffect(() => {
    if (processFlow) {
      fetchProcessFlows();
      setProcessFlow(false);
    }
  }, [processFlow]);

    const fetchRecheckTimeWindowConfig = async () => {
    setRecheckLoading(true);
    setRecheckError(null);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchRecheckTimeWindowConfig`;
      const response = await axios.get(url);
      const data = response?.data;
      if (data?.status === true || data?.status === "true") {
        setRecheckTimeWindows(data.data?.recheckConfigList || []);
      } else {
        setRecheckError(data?.message || "Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setRecheckError("Something went wrong. Please try again.");
    } finally {
      setRecheckLoading(false);
    }
  };

  useEffect(() => {
    fetchRecheckTimeWindowConfig();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (recheckTimeWindowRefresh) {
      fetchRecheckTimeWindowConfig();
      setRecheckTimeWindowRefresh(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recheckTimeWindowRefresh]);

  const fetchShipmentConfigsCount = async () => {
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchShipmentConfig`;
      const response = await axios.get(url);
      if (response.data?.status) {
        setShipmentConfigs(response.data?.data || []);
      }
    } catch (err) {
      console.error("Error fetching shipment configs:", err);
    }
  };

  useEffect(() => {
    fetchShipmentConfigsCount();
  }, [shipmentConfig]);

  
  const handleTabClick = (index) => {
    setValue(index);
    if (handleOpenTab) {
      handleOpenTab(index);
    }
  };
  const handleNext = () => {
    if (value < tabConfigs.length - 1) {
      setValue(value + 1);
    }
  };

  const handleBack = () => {
    if (value > 0) {
      setValue(value - 1);
    }
  };

  const tabConfigs = [
    {
      // label: "Product Modality ",
      label: `Product Modality (${modalities.length})`,
      component: <ProductModalityTab 
        handleNext={handleNext}
        setProductModalities={setProductModalities}
        featuresAccess={featuresAccess}
        sponsorId={sponsorId}
      />,
    },
    {
      // label: "Manufacturing Supply Type ",
       label: `Manufacturing Supply Type (${supplyTypes.length})`,
      component: (
        <ManufacturingSupplyTab
          setManufacturingSupplyTypes={setManufacturingSupplyTypes}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
          // handleNext={handleNext}
          // handleBack={handleBack}
        />
      ),
    },
    {
      // label: "Plant Type ",
        label: `Plant Type (${plantTypes.length})`,
      component: (
        <PlantTypeTab
          setPlantType={setPlantType}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
          // handleNext={handleNext} handleBack={handleBack}
        />
      ),
    },
    {
      // label: "UOM ",
      label: `UOM (${uoms.length})`,
      component: (
        <UOMTab
          setUom={setUom}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
          // handleNext={handleNext} handleBack={handleBack}
        />
      ),
    },
    {
      // label: "Reason Code Group ",
       label: `Reason Code Group (${reasonCodes.length})`,
      component: (
        <ReasonCodeGroupComponent
          handleNext={handleNext}
          handleBack={handleBack}
          setReasonCodesData={setReasonCodesData}
          featuresAccess={featuresAccess}
          // reasonCodesData={reasonCodesData}
         // setReasonCodesData={setReasonCodesData}
        />
      ),
    },
    {
      // label: "Material Type ",
       label: `Material Type (${materialTypes.length})`,
       component: (
           <MaterialTypeTab
               setMaterialType={setMaterialType}
               onMaterialTypesChange={setMaterialTypes}
               featuresAccess={featuresAccess}
               sponsorId={sponsorId}
           />
       ),
    },
    {
      // label: "Product Type ",
       label: `Product Type (${productTypes.length})`,
      component: (
        <ProductTypeTab
          setProductType={setProductType}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
          // handleNext={handleNext}
          // handleBack={handleBack}
        // handleNext={handleNext} handleBack={handleBack}
        />
      ),
    },
    {
      // label: "Manufacturing Facility Type ",
      label: `Manufacturing Facility Type (${facilityTypes.length})`,
      component: (
        <ManufacturingFacilityTypeTab
          setManufacturingFacilityType={setManufacturingFacilityType}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
          // handleNext={handleNext}
          // handleBack={handleBack}
        />
      ),
    },
    {
      // label: "PO Status ",
        label: `PO Status (${poStatuses.length})`,
      component: (
        <POStatusTab 
          handleNext={handleNext} 
          handleBack={handleBack} 
          setPoStatus={setPoStatus}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      // label: "Batch Status ",
      label: `Batch Status (${batchStatuses.length})`,
      component: (
        <BatchStatusTab 
          handleNext={handleNext} 
          handleBack={handleBack} 
          setBatchStatus={setBatchStatus}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      label: `Project Management (${projectStatuses.length + campaignStatuses.length + changeControlStatuses.length + deviationStatuses.length + inProcessTestStatuses.length + productReleaseTestStatuses.length})`,
      component: (
        <StatusManagementTab 
          handleNext={handleNext} 
          handleBack={handleBack} 
          setProjectStatus={setProjectStatus}
          setCampaignStatus={setCampaignStatus}
          setChangeControlStatus={setChangeControlStatus}
          setDeviationStatus={setDeviationStatus}
          setInProcessTestStatus={setInProcessTestStatus}
          setProductReleaseTestStatus={setProductReleaseTestStatus}
          featuresAccess={featuresAccess}
        />
      ),
    },
    {
      // label: "Shipment Status ",
      label: `Shipment Status (${shipmentStatuses.length})`,
      component: (
        <ShipmentStatusTab
          handleNext={handleNext}
          handleBack={handleBack}
          setShipmentStatus={setShipmentStatus}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    // 3PL Logistics — Sponsor Network: new master-data tabs (FSD).
    // Placed immediately after Shipment Status as requested.
    // (Consignee Type tab is deferred to a later iteration.)
    {
      label: `Temperature (${temperatures.length})`,
      component: (
        <TemperatureTab
          handleNext={handleNext}
          handleBack={handleBack}
          setTemperature={setTemperature}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      label: `Truck Capacity (${truckCapacities.length})`,
      component: (
        <TruckCapacityTab
          handleNext={handleNext}
          handleBack={handleBack}
          setTruckCapacity={setTruckCapacity}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      // label: "Document Groups ",
      label: `Document Groups (${documentGroups.length})`,
      component: (
        <DocumentGroupsTab 
          handleNext={handleNext} 
          handleBack={handleBack}
          setDocumentGroup={setDocumentGroup}
          featuresAccess={featuresAccess}
        />
      ),
    },
    {
      // label: "Document Categories ",
      label: `Document Categories (${documentCategories.length})`,
      component: (
        <DocumentCategoriesTab 
          handleNext={handleNext} 
          handleBack={handleBack}
          setDocumentCategory={setDocumentCategory}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      // label: "Document Type ",
       label: `Document Type (${documentTypes.length})`,
      component: (
        <DocumentTypeTab 
          handleNext={handleNext} 
          handleBack={handleBack}
          setDocumentType={setDocumentType}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      // label: "Format Type ",
      label: `Format Type (${formatTypes.length})`,
      component: (
        <FormatTypeTab 
          handleNext={handleNext} 
          handleBack={handleBack}
          setFormatType={setFormatType}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      label: `Process Flow (${processFlows.length})`,
      component: <ProcessFlowTab 
        setProcessFlow={setProcessFlow}
        featuresAccess={featuresAccess}
        sponsorId={sponsorId}
      />,
    },
    {
      label: `Digitalization Codes (${digitalizationCodes.length})`,
      component: (
        <DigitalizationCodesTab
          handleNext={handleNext}
          handleBack={handleBack}
          setDigitalizationCode={setDigitalizationCode}
          featuresAccess={featuresAccess}
          sponsorId={sponsorId}
        />
      ),
    },
    {
      label: `Shipment Config (${shipmentConfigs.length})`,
      component: (
        <ShipmentConfigTab
          handleNext={handleNext}
          handleBack={handleBack}
          setShipmentConfig={setShipmentConfig}
          onShipmentConfigsFetched={(list) => setShipmentConfigs(list)}
          featuresAccess={featuresAccess}
        />
      ),
    },
    {
      label: `Recheck Time Window (${recheckTimeWindows.length})`,
      onEnter: fetchRecheckTimeWindowConfig,
      component: (
        <RecheckTimeWindowTab
          recheckTimeWindowConfig={recheckTimeWindows}
          setRecheckTimeWindowRefresh={setRecheckTimeWindowRefresh}
          loading={recheckLoading}
          error={recheckError}
          handleNext={handleNext}
          handleBack={handleBack}
          featuresAccess={featuresAccess}
        />
      ),
    },
    // {
    //   label: "Fetch/Upload Setting ",
    //   component: (
    //     <UploadFetchSettingTab
    //       sponsorHandleNext={sponsorHandleNext}
    //       handleBack={handleBack}
    //     />
    //   ),
    // },
  ];

  return (
    <div className={classes.root}>
      {/* Header */}
      {/* <div className={classes.headerContainer} style={{ marginBottom: "2rem" }}>
        <Typography className={classes.headerText}>
          Sponsor Network Configurations
        </Typography>
        <hr className={classes.headerLine} />
      </div> */}

      {/* Tabs Container */}
      <div className={classes.tabsContainer}>
        {tabConfigs.map((tab, index) => (
          <CustomTab
            key={index}
            label={tab.label}
            isActive={value === index}
            onClick={() => { setValue(index); tab.onEnter?.(); }}
          />
        ))}
      </div>

      {/* Tab Content */}
      <div className={classes.tabContent}>
        {tabConfigs.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </div>
    </div>
  );
};

export default SponsorNetworkTabs;

